import { Grid, Paper, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

export const MembershipFee = () => {
    return (
        <Paper square>
            <Grid container direction="column" p={2}>
                <Grid item>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <CircleIcon fontSize="small" />
                        </Grid>
                        <Grid item>
                            <Typography>会費</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography variant="body2" ml={3}>1か月 1,500円</Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2" ml={3}>※スポーツ保険（年800円）別</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
